import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';
import { API_PATHS } from '../../helpers/endpoints';
import { getFilterStockTransaction } from '../requests/stock';

export default {
  getFilterStockTracking: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STOCK_INVENTORY}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getFilterStockTransaction: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STOCK_INVENTORY}/transactions?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllStockTransactionForCsv: async (payload) => {
    const { queryString, ...data } = payload;
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.STOCK_INVENTORY}/reports/create-and-send-transaction-csv?${queryString}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getAllStockInventoryForCsv: async (payload) => {
    const { queryString, ...data } = payload;
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.STOCK_INVENTORY}/reports/create-and-send-inventory-csv?${queryString}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
